module.exports = __webpack_public_path__ + "e7dcd4512e716dbf299dc95b6981e759.svg";